webpackJsonp([33],{

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

__webpack_require__(181);
var $ = __webpack_require__(0);
var csvSeparator = ",,";

//https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
function updateUrlParameter(uri, key, value) {
    // remove the hash part before operating on the uri
    var i = uri.indexOf('#');
    var hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        uri = uri + separator + key + "=" + value;
    }

    uri = uri.replace(/&?[^&?]+=(?=(?:&|$))/g, ''); // On enlève les paramètres vide
    uri = uri.replace(/\?&/g, '?'); // On remplace le '?$' par '?'
    uri = uri.replace(/\?$/g, ''); // On enlève le ? qui reste seul 

    return uri + hash; // finally append the hash as well
}

function reloadPage(url) {

    url = updateUrlParameter(url, "page", 1);

    if (url.indexOf('#') <= 0) {
        url += "#filtres-recherche";
    }

    window.location.href = url;
}

function getCheckboxName(key) {
    return $(".m-filter-dropdown[data-parameter-key='" + key + "']").find("input[type=checkbox]").first().attr("name");
}

function encodeFilterValue(value) {
    return encodeURIComponent(value).replace(/%20/g, "+");
}

var refreshText = $("#refresh-label").text();

$('[data-controller="filter"]').each(function () {
    var $filter = $('[data-filter="filter"]', this);

    $filter.each(function () {
        var $dropdown = $(this).next('[data-filter="dropdown"]'),
            $allDropdowns = $('[data-filter="dropdown"]'),
            $allFilters = $('[data-filter="filter"]'),
            $this = $(this),
            activeClass = 'o-search-filters__list-item-btn--active';
        $this.on('click', function (e) {
            e.stopPropagation();
            $allDropdowns.not($dropdown).slideUp();
            $dropdown.slideToggle();
            $allFilters.not($this).removeClass(activeClass);
            $this.toggleClass(activeClass);
        });
        $(document).on('click', function (e) {
            if (!$allDropdowns.is(e.target) && $allDropdowns.has(e.target).length === 0) {
                $allDropdowns.slideUp();
                $allFilters.removeClass(activeClass);
            }
        });
    });

    var searchParams = new URLSearchParams(window.location.search);

    var filterKeys = $(".m-filter-dropdown").get().map(function (x) {
        return $(x).data('parameter-key');
    });
    var hasFilterKeys = filterKeys.some(function (x) {
        return searchParams.has(x);
    });
    var filterAndSearchKeys = filterKeys.concat(["mots-cles"]);
    var hasSearchKeys = filterAndSearchKeys.some(function (x) {
        return searchParams.has(x);
    });

    if (hasSearchKeys) {
        $(".o-search-filters__active-filters-container").show();
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = _slicedToArray(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            if (!value || !filterAndSearchKeys.includes(key)) continue;
            if (key != "mots-cles") {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = value.split(csvSeparator)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var val = _step2.value;

                        if (!val) continue;
                        var checkboxName = getCheckboxName(key);
                        var checkbox = $("label[for='" + checkboxName + "-" + encodeFilterValue(val) + "']");
                        appendActivefilter(val, key, checkbox.text());
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            } else {
                appendActivefilter(value, key, value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    function appendActivefilter(filterValue, key, text) {
        $('.o-search-filters__active-filters').append("<button class=\"o-search-filters__active-filters-btn\" data-filter-value=\"" + filterValue + "\" data-filter-key=\"" + key + "\">" + text + "\n            <svg  class=\"o-search-filters__erase-btn-icon\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M10.9375 3.0625L3.0625 10.9375\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n            <path d=\"M10.9375 10.9375L3.0625 3.0625\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n            </svg></button>");
    }

    $('.o-search-filters__active-filters-btn').each(function () {
        var $button = $(this);
        var key = $button.data('filter-key');
        var value = $button.data('filter-value');

        if (key == "mots-cles") {
            $button.off('click');
            $button.on('click', function (e) {
                var input = $(".m-filter-keyword__input");
                input.val('');
                $("[data-apply-search-filters]").text(refreshText);
                $(this).remove();
            });

            return;
        }

        var checkboxName = getCheckboxName(key);

        $button.off('click');
        $button.on('click', function (e) {
            var checkbox = $("input[type=checkbox][name='" + checkboxName + "'][value='" + encodeFilterValue(value) + "']");
            checkbox.trigger("click");
            $(this).remove();
        });
    });

    $('[data-filter-dropdown-option]').each(function () {
        var $checkbox = $(this);
        var $dropdownLabel = $checkbox.closest(".o-search-filters__list-item-dropdown").siblings(".o-search-filters__list-item-btn").children(".o-search-filters__list-item-count");

        var dropDownCheckedCount = parseInt($dropdownLabel.text());
        if (!dropDownCheckedCount) {
            dropDownCheckedCount = 0;
            $dropdownLabel.text(dropDownCheckedCount);
            $dropdownLabel.attr("disabled", true);
        }

        $checkbox.off('click');
        $checkbox.on('click', function (e) {
            var dropDownCheckedCount = parseInt($dropdownLabel.text());
            if (!dropDownCheckedCount) {
                dropDownCheckedCount = 0;
            }

            if ($(this).is(':checked')) {
                $dropdownLabel.text(++dropDownCheckedCount);
                $dropdownLabel.removeAttr("disabled");
                $dropdownLabel.css("display", "inline-block");
            } else {
                $dropdownLabel.text(--dropDownCheckedCount);
                if (dropDownCheckedCount == 0) {
                    $dropdownLabel.attr("disabled", true);
                }
            }

            if (hasSearchKeys) {
                $("[data-apply-search-filters]").text(refreshText);
            }
        });

        $dropdownLabel.css("display", "inline-block");
        if ($checkbox.is(':checked')) {
            $dropdownLabel.text(++dropDownCheckedCount);
            $dropdownLabel.removeAttr("disabled");
        }
    });

    /*
     Lancement de la recherche
    */
    $('[data-apply-search-filters]').each(function () {

        var $applyButton = $(this);
        var url = window.location.href;

        $applyButton.off('click.o-search-filters');
        $applyButton.on('click.o-search-filters', function (e) {
            e.preventDefault();
            url = getUrlWithAllDropdownValues(url);

            reloadPage(url);
        });
    });

    $('.o-search-filters__erase-btn').each(function () {
        var $eraseButton = $(this);
        $eraseButton.off('click.o-erase-btn');
        $eraseButton.on('click.o-erase-btn', function (e) {
            e.preventDefault();
            $('.o-search-filters__active-filters-btn').trigger("click");
        });
    });

    function getUrlWithAllDropdownValues(baseUrl) {

        var url = baseUrl;

        $('[data-filter-dropdown]').each(function () {

            var $dropDown = $(this);

            var value = getDropDownQueryStringValue();
            var parameterKey = $dropDown.data('parameter-key');
            url = updateUrlParameter(url, parameterKey, value);

            function getDropDownQueryStringValue() {

                var qsValues = [];

                $('[data-filter-dropdown-option]', $dropDown).each(function () {
                    var $option = $(this);

                    if (!$option.is(':checked')) {
                        return;
                    }

                    qsValues.push($option.val());
                });

                return qsValues.join(csvSeparator);
            }
        });

        $('[data-filter-keyword]').each(function () {
            var $keywords = $(this);
            var $searchBox = $('[data-search-box]', $keywords);
            var parameterKey = $keywords.data('parameter-key');
            var value = $searchBox.val();
            url = updateUrlParameter(url, parameterKey, value);
        });

        return url;
    }

    var filterKeywordValue = "";
    /*
     Lancement de la recherche : Pour les mot-clés
    */
    $('[data-filter-keyword]').each(function () {
        var $keywords = $(this);
        var $searchBox = $('[data-search-box]', $keywords);
        var $applyButton = $('[data-apply]', $keywords);
        var parameterKey = $keywords.data('parameter-key');
        var url = window.location.href;

        $applyButton.off('click.o-search-filters');
        $applyButton.on('click.o-search-filters', function (e) {
            e.preventDefault();
            url = getUrlWithAllDropdownValues(url);

            reloadPage(url);
        });

        $searchBox.off('keydown.o-search-filters');
        $searchBox.on('keydown.o-search-filters', function (e) {
            filterKeywordValue = $(this).val();
        });
        $searchBox.off('keyup.o-search-filters');
        $searchBox.on('keyup.o-search-filters', function (e) {
            var val = $(this).val();

            if (filterKeywordValue != val) {
                $("[data-apply-search-filters]").text(refreshText);
                filterKeywordValue = val;
            }
        });
        $searchBox.off('keypress.o-search-filters');
        $searchBox.on('keypress.o-search-filters', function (e) {
            $("[data-apply-search-filters]").text(refreshText);

            if (e.which !== 13) {
                return true;
            }

            e.preventDefault();
            url = getUrlWithAllDropdownValues(url);

            reloadPage(url);
        });
    });
});

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[180]);


// WEBPACK FOOTER //
// o-search-filters.js